<template>
  <div class="modal_wrap on">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">필터</h1>
        </div>
        <div class="modal_con">
          <div class="form_wrap">
            <div class="form_li">
              <div class="form_in">
                <div class="check_table" data-columns="3">
                  <!--'2열: data-columns="2"', '3열: data-columns="3"'-->
                  <label
                    ><input
                      type="radio"
                      name="sort"
                      value="CREATED_AT_DESC"
                      v-model="options.orderType"
                    /><span>최신순</span></label
                  >
                  <label
                    ><input
                      type="radio"
                      name="sort"
                      value="CREATED_AT_ASC"
                      v-model="options.orderType"
                    /><span>오래된 순</span></label
                  >
                  <label
                    ><input
                      type="radio"
                      name="sort"
                      value="STORE_COUNT"
                      v-model="options.orderType"
                    /><span>매장 많은 순</span></label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn" @click="$emit('close', options)">확인</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filter: Object,
  },
  data() {
    return {
      options: {
        orderType: 'CREATED_AT_DESC',
      },
    };
  },
  created() {
    this.options.orderType = this.filter.orderType || this.options.orderType;
  },
  computed: {},
};
</script>
